"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Typos = {
    baseFs: 16,
    baseLh: 1.25,
    weightThin: 100,
    weightExtralight: 200,
    weightLight: 300,
    weightNormal: 400,
    weightMedium: 500,
    weightSemibold: 600,
    weightBold: 700,
    weightExtrabold: 800,
    weightBlack: 900,
};
exports.default = Typos;
//# sourceMappingURL=Typos.js.map